var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 0.333496C8.78959 0.333496 6.79175 0.939535 5.09244 2.07498C3.39314 3.21042 2.06869 4.82426 1.28658 6.71243C0.504477 8.6006 0.299843 10.6783 0.698557 12.6828C1.09727 14.6872 2.08142 16.5284 3.52657 17.9736C4.97171 19.4187 6.81293 20.4029 8.8174 20.8016C10.8219 21.2003 12.8996 20.9957 14.7877 20.2136C16.6759 19.4315 18.2897 18.107 19.4252 16.4077C20.5606 14.7084 21.1667 12.7106 21.1667 10.6668C21.1667 9.30983 20.8994 7.96613 20.3801 6.71243C19.8608 5.45873 19.0996 4.3196 18.1401 3.36006C17.1806 2.40052 16.0414 1.63937 14.7877 1.12007C13.534 0.600776 12.1903 0.333496 10.8333 0.333496ZM11.8667 10.6668C11.8674 10.8028 11.8414 10.9376 11.79 11.0635C11.7385 11.1894 11.6628 11.3039 11.567 11.4005L8.467 14.5005C8.26932 14.6698 8.01504 14.7582 7.75498 14.7482C7.49491 14.7381 7.24822 14.6303 7.06418 14.4463C6.88015 14.2623 6.77234 14.0156 6.7623 13.7555C6.75225 13.4954 6.84071 13.2412 7.01 13.0435L9.8 10.2432V5.50016C9.8 5.2261 9.90887 4.96327 10.1027 4.76948C10.2964 4.5757 10.5593 4.46683 10.8333 4.46683C11.1074 4.46683 11.3702 4.5757 11.564 4.76948C11.7578 4.96327 11.8667 5.2261 11.8667 5.50016V10.6668Z",
    fill: "#ED8936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.f95b1699797d34535a7f5f006b264c15.svg";
export { ForwardRef as ReactComponent };